import React from "react";
import { MainMenu } from "@Components";
import Grid from "@mui/material/Grid";
import {
    Container,
    Middle,
    MainMenuWrapper,
    GuestInnerContainer,
} from "@Styled/Layout";

const withPublicLayout = (WrappedComponent: React.FC) => (props: any) => {
    return (
        <>
            <MainMenuWrapper>
                <MainMenu />
            </MainMenuWrapper>
            <Container>
                <Middle>
                    <GuestInnerContainer>
                        <Grid container>
                            <Grid item xs={12}>
                                <WrappedComponent
                                    id="wrapped-default-layout"
                                    {...props}
                                />
                            </Grid>
                        </Grid>
                    </GuestInnerContainer>
                </Middle>
            </Container>
        </>
    );
};

export default withPublicLayout;
